type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
};

const FacebookLikeReactionBadge = (props: Props) => {
  const { width = '18', height = '18', viewBox = '0 0 18 18' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
    >
      <defs>
        <linearGradient id="fbLikeGrad" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#18AFFF" />
          <stop offset="100%" stopColor="#0062DF" />
        </linearGradient>
      </defs>
      <circle cx="9" cy="9" r="9" fill="url(#fbLikeGrad)" />
      <g transform="translate(9 9) scale(1.15) translate(-9 -9)">
        <path
          d="M7.7 7.5l1.55-2.4c.25-.4.78-.55 1.2-.32.35.18.52.6.42.98l-.45 1.74h2.18c.58 0 1.04.5.96 1.07l-.4 2.85c-.07.46-.46.8-.93.8H7.7zm-1.5 0H4.7c-.28 0-.5.22-.5.5v3.95c0 .28.22.5.5.5h1.5z"
          fill="#FFFFFF"
        />
      </g>
    </svg>
  );
};

export default FacebookLikeReactionBadge;
